import { formatPrice } from "@luce/core";
import { Box, Divider, Typography } from "@luce/ui";

import { SINGAPORE_TAX } from "../../constant";
import { getInvoiceBalance, getInvoiceDiscount } from "../../lib";
import type { InvoiceDetailData } from "../../types";
import { InvoiceDetailRow } from "./invoice-detail-row";
import { InvoiceSection } from "./invoice-section";

const VOUCHER_LABEL = "Discount Voucher";

export function InvoicePaymentSummary({ invoice }: { invoice: InvoiceDetailData }) {
  const discount = getInvoiceDiscount(invoice);
  const hasGst = invoice.amount > 0;
  const voucherLabel =
    invoice.appliedVoucher && discount > 0
      ? `${VOUCHER_LABEL} (${invoice.appliedVoucher.discountValue}%)`
      : VOUCHER_LABEL;

  return (
    <InvoiceSection icon="Receipt" title="Payment Summary">
      <Box className="gap-spacing-sm flex flex-col">
        <InvoiceDetailRow label="Subtotal" divider={false}>
          {formatPrice(invoice.lineItemsTotal)}
        </InvoiceDetailRow>
        {invoice.appliedVoucher && (
          <InvoiceDetailRow label={voucherLabel} divider={false}>
            {`-${formatPrice(discount)}`}
          </InvoiceDetailRow>
        )}
        {hasGst && (
          <InvoiceDetailRow label={`GST (${SINGAPORE_TAX * 100}%)`} divider={false}>
            {formatPrice(invoice.amount)}
          </InvoiceDetailRow>
        )}
        {invoice.paidAmount > 0 && (
          <InvoiceDetailRow label="Confirmed Payment" divider={false}>
            {`-${formatPrice(invoice.paidAmount)}`}
          </InvoiceDetailRow>
        )}
      </Box>

      <Divider />

      <Box className="gap-spacing-md flex flex-row items-baseline justify-between">
        <Typography variant="body-sm" color="neutral-foreground-default">
          Total Amount
        </Typography>
        <Box className="gap-spacing-xs flex flex-row items-baseline">
          <Typography variant="label-sm" color="brand-primary">
            {formatPrice(getInvoiceBalance(invoice))}
          </Typography>
          {hasGst && (
            <Typography variant="caption-md" color="neutral-foreground-intermediate">
              incl. GST
            </Typography>
          )}
        </Box>
      </Box>
    </InvoiceSection>
  );
}
